import { isEmpty, pickBy } from "lodash";
import { createSelector } from "reselect";
import { getMenuSpaceId } from "~/Redux/Spaces";
import { PresetsState } from "../../types";
import { Presets } from "../reducers/entities";

export const getPresets = (state: PresetsState) => state.entities.presets;
export const isPresetListLoaded = (state: PresetsState) => !isEmpty(state.entities.presets);

export const getPresetsForSpace = createSelector(getPresets, getMenuSpaceId, (presets: Presets, spaceId: number) =>
    pickBy(presets || {}, x => x.SpaceId === spaceId)
);

export const getPresetById = (presets: Presets, presetId: number) => {
    return (presets || {})[presetId] || null;
};

export const getTempPreset = createSelector(
    getPresets,
    presets => Object.values(presets || {}).find(p => p.IsTemporary) || null
);

export const getDefaultPreset = createSelector(
    getPresetsForSpace,
    presets => Object.values(presets).find(p => p.IsDefault) || null
);
